import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  Char__rangeTo_impl_tkncvpnglpnjmwahwh as Char__rangeTo_impl_tkncvp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance2wec3srl1ini as Companion_instance } from './AsciiBitSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ILLEGAL_HEADER_NAME_CHARS() {
  _init_properties_HttpHeaders_kt__8vtb1o();
  return ILLEGAL_HEADER_NAME_CHARS;
}
var ILLEGAL_HEADER_NAME_CHARS;
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.y4z_1 = 'Accept';
        this.z4z_1 = 'Accept-Charset';
        this.a50_1 = 'Accept-Encoding';
        this.b50_1 = 'Accept-Language';
        this.c50_1 = 'Accept-Ranges';
        this.d50_1 = 'Age';
        this.e50_1 = 'Allow';
        this.f50_1 = 'ALPN';
        this.g50_1 = 'Authentication-Info';
        this.h50_1 = 'Authorization';
        this.i50_1 = 'Cache-Control';
        this.j50_1 = 'Connection';
        this.k50_1 = 'Content-Disposition';
        this.l50_1 = 'Content-Encoding';
        this.m50_1 = 'Content-Language';
        this.n50_1 = 'Content-Length';
        this.o50_1 = 'Content-Location';
        this.p50_1 = 'Content-Range';
        this.q50_1 = 'Content-Type';
        this.r50_1 = 'Cookie';
        this.s50_1 = 'DASL';
        this.t50_1 = 'Date';
        this.u50_1 = 'DAV';
        this.v50_1 = 'Depth';
        this.w50_1 = 'Destination';
        this.x50_1 = 'ETag';
        this.y50_1 = 'Expect';
        this.z50_1 = 'Expires';
        this.a51_1 = 'From';
        this.b51_1 = 'Forwarded';
        this.c51_1 = 'Host';
        this.d51_1 = 'HTTP2-Settings';
        this.e51_1 = 'If';
        this.f51_1 = 'If-Match';
        this.g51_1 = 'If-Modified-Since';
        this.h51_1 = 'If-None-Match';
        this.i51_1 = 'If-Range';
        this.j51_1 = 'If-Schedule-Tag-Match';
        this.k51_1 = 'If-Unmodified-Since';
        this.l51_1 = 'Last-Modified';
        this.m51_1 = 'Location';
        this.n51_1 = 'Lock-Token';
        this.o51_1 = 'Link';
        this.p51_1 = 'Max-Forwards';
        this.q51_1 = 'MIME-Version';
        this.r51_1 = 'Ordering-Type';
        this.s51_1 = 'Origin';
        this.t51_1 = 'Overwrite';
        this.u51_1 = 'Position';
        this.v51_1 = 'Pragma';
        this.w51_1 = 'Prefer';
        this.x51_1 = 'Preference-Applied';
        this.y51_1 = 'Proxy-Authenticate';
        this.z51_1 = 'Proxy-Authentication-Info';
        this.a52_1 = 'Proxy-Authorization';
        this.b52_1 = 'Public-Key-Pins';
        this.c52_1 = 'Public-Key-Pins-Report-Only';
        this.d52_1 = 'Range';
        this.e52_1 = 'Referer';
        this.f52_1 = 'Retry-After';
        this.g52_1 = 'Schedule-Reply';
        this.h52_1 = 'Schedule-Tag';
        this.i52_1 = 'Sec-WebSocket-Accept';
        this.j52_1 = 'Sec-WebSocket-Extensions';
        this.k52_1 = 'Sec-WebSocket-Key';
        this.l52_1 = 'Sec-WebSocket-Protocol';
        this.m52_1 = 'Sec-WebSocket-Version';
        this.n52_1 = 'Server';
        this.o52_1 = 'Set-Cookie';
        this.p52_1 = 'SLUG';
        this.q52_1 = 'Strict-Transport-Security';
        this.r52_1 = 'TE';
        this.s52_1 = 'Timeout';
        this.t52_1 = 'Trailer';
        this.u52_1 = 'Transfer-Encoding';
        this.v52_1 = 'Upgrade';
        this.w52_1 = 'User-Agent';
        this.x52_1 = 'Vary';
        this.y52_1 = 'Via';
        this.z52_1 = 'Warning';
        this.a53_1 = 'WWW-Authenticate';
        this.b53_1 = 'Access-Control-Allow-Origin';
        this.c53_1 = 'Access-Control-Allow-Methods';
        this.d53_1 = 'Access-Control-Allow-Credentials';
        this.e53_1 = 'Access-Control-Allow-Headers';
        this.f53_1 = 'Access-Control-Request-Method';
        this.g53_1 = 'Access-Control-Request-Headers';
        this.h53_1 = 'Access-Control-Expose-Headers';
        this.i53_1 = 'Access-Control-Max-Age';
        this.j53_1 = 'X-Http-Method-Override';
        this.k53_1 = 'X-Forwarded-Host';
        this.l53_1 = 'X-Forwarded-Server';
        this.m53_1 = 'X-Forwarded-Proto';
        this.n53_1 = 'X-Forwarded-For';
        this.o53_1 = 'X-Forwarded-Port';
        this.p53_1 = 'X-Request-ID';
        this.q53_1 = 'X-Correlation-ID';
        this.r53_1 = 'X-Total-Count';
        this.s53_1 = 'Last-Event-ID';
        this.t53_1 = 'TDM-Reservation';
        this.u53_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v53_1 = ['Transfer-Encoding', 'Upgrade'];
        this.w53_1 = asList(this.v53_1);
      }
      x53(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (get_ILLEGAL_HEADER_NAME_CHARS().xp(item)) {
            throw IllegalHeaderNameException().h54(name, _unary__edvuaz);
          }
        }
      }
      y53(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().o54(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(header) {
        return new.target.t54(header);
      }
      static t54(header) {
        var $this = this.o2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.s54_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerName, position) {
        return new.target.h54(headerName, position);
      }
      static h54(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.o2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.g54_1);
        $this.e54_1 = headerName;
        $this.f54_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerValue, position) {
        return new.target.o54(headerValue, position);
      }
      static o54(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.o2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.n54_1);
        $this.l54_1 = headerValue;
        $this.m54_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
var properties_initialized_HttpHeaders_kt_3d6wem;
function _init_properties_HttpHeaders_kt__8vtb1o() {
  if (!properties_initialized_HttpHeaders_kt_3d6wem) {
    properties_initialized_HttpHeaders_kt_3d6wem = true;
    ILLEGAL_HEADER_NAME_CHARS = Companion_instance.z4w(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(0), _Char___init__impl__6a9atx(32))).b4x(Companion_instance.b3o('"(),/:;<=>?@[\\]{}'));
  }
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance1avhj7ffsen7f,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
